var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "28px",
    viewBox: "0 0 25 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content---6-months-in",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-Explorer---Article-Preview",
    transform: "translate(-905.000000, -568.000000)",
    fill: "#424B50",
    fillRule: "nonzero",
    stroke: "#424B50",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(817.112782, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(82.887218, 474.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_lightbulb_3194358-copy",
    transform: "translate(6.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8456,4.6096 C9.916,4.5292 8.0668,5.1992 6.6732,6.5392 C5.2796,7.8792 4.5024,9.6748 4.5024,11.6044 C4.5024,13.1856 5.0116,14.6864 6.0032,15.946 C6.8608,17.0448 7.4504,18.09 7.8256,19.1888 L7.8524,19.2692 L7.8524,22.0832 C7.8524,22.4316 8.1204,22.7532 8.4688,22.8068 C8.6028,24.3612 9.916,25.594 11.524,25.594 C13.132,25.594 14.4452,24.3612 14.5792,22.78 C14.9276,22.7264 15.1956,22.4316 15.1956,22.0564 L15.1956,19.2692 L15.2224,19.1888 C15.5976,18.09 16.1872,17.0448 17.0448,15.9728 C18.09,14.6596 18.626,12.998 18.5456,11.3364 C18.358,7.7184 15.4368,4.7704 11.8456,4.6096 Z M13.7216,19.564 L13.7216,21.3328 L9.3264,21.3328 L9.3264,19.564 L13.7216,19.564 Z M11.524,24.12 C10.72,24.12 10.0768,23.5304 9.9428,22.78 L13.1052,22.78 C12.9712,23.5572 12.328,24.12 11.524,24.12 Z M15.8656,15.0348 C15.0616,16.0532 14.472,17.0448 14.0432,18.09 L9.0048,18.09 C8.576,17.0716 7.9864,16.0532 7.1824,15.0348 C6.4052,14.0432 6.0032,12.864 6.0032,11.6044 C6.0032,10.0768 6.6196,8.6564 7.7184,7.5844 C8.8172,6.5392 10.2644,5.9764 11.8188,6.0568 C14.6596,6.1908 16.9644,8.5224 17.0984,11.3364 C17.1252,12.7032 16.6964,13.9896 15.8656,15.0348 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.524,2.948 C11.926,2.948 12.2476,2.6264 12.2476,2.2244 L12.2476,0.8576 C12.2476,0.4556 11.926,0.134 11.524,0.134 C11.122,0.134 10.8004,0.4556 10.8004,0.8576 L10.8004,2.2244 C10.8004,2.6264 11.122,2.948 11.524,2.948 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1908,3.8592 C6.3248,4.1004 6.566,4.2344 6.834,4.2344 C6.968,4.2344 7.0752,4.2076 7.2092,4.1272 C7.5576,3.9128 7.6916,3.484 7.4772,3.1356 L6.8072,1.9564 C6.5928,1.608 6.164,1.474 5.8156,1.6884 C5.4672,1.9028 5.3332,2.3316 5.5476,2.68 L6.1908,3.8592 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.752,6.2712 L2.5728,5.6012 C2.2244,5.3868 1.7688,5.5208 1.5812,5.8692 C1.3668,6.2176 1.5008,6.6732 1.8492,6.8608 L3.0284,7.5308 C3.1356,7.5844 3.2696,7.638 3.4036,7.638 C3.6448,7.638 3.9128,7.504 4.0468,7.2628 C4.2344,6.9412 4.1004,6.4856 3.752,6.2712 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8676,11.6044 C2.8676,11.2024 2.546,10.8808 2.144,10.8808 L0.7772,10.8808 C0.3752,10.8808 0.0536,11.2024 0.0536,11.6044 C0.0536,12.0064 0.3752,12.328 0.7772,12.328 L2.144,12.328 C2.546,12.3548 2.8676,12.0064 2.8676,11.6044 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0284,15.678 L1.8492,16.348 C1.5008,16.5624 1.3668,16.9912 1.5812,17.3396 C1.7152,17.5808 1.9564,17.7148 2.2244,17.7148 C2.3584,17.7148 2.4656,17.688 2.5996,17.6076 L3.7788,16.9376 C4.1272,16.7232 4.2612,16.2944 4.0468,15.946 C3.8324,15.5976 3.3768,15.4636 3.0284,15.678 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1988,16.348 L20.0196,15.678 C19.6712,15.4636 19.2156,15.5976 19.028,15.946 C18.8136,16.2944 18.9476,16.75 19.296,16.9376 L20.4752,17.6076 C20.5824,17.6612 20.7164,17.7148 20.8504,17.7148 C21.0916,17.7148 21.3596,17.5808 21.4936,17.3396 C21.6544,16.9912 21.5472,16.5624 21.1988,16.348 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2708,10.8808 L20.904,10.8808 C20.502,10.8808 20.1804,11.2024 20.1804,11.6044 C20.1804,12.0064 20.502,12.328 20.904,12.328 L22.2708,12.328 C22.6728,12.328 22.9944,12.0064 22.9944,11.6044 C22.9944,11.2024 22.6728,10.8808 22.2708,10.8808 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6444,7.638 C19.7784,7.638 19.8856,7.6112 20.0196,7.5308 L21.1988,6.8608 C21.5472,6.6464 21.6812,6.2176 21.4668,5.8692 C21.2524,5.5208 20.8236,5.3868 20.4752,5.6012 L19.296,6.2712 C18.9476,6.4856 18.8136,6.9144 19.028,7.2628 C19.162,7.5308 19.4032,7.638 19.6444,7.638 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8388,4.1272 C15.946,4.1808 16.08,4.2344 16.214,4.2344 C16.4552,4.2344 16.7232,4.1004 16.8572,3.8592 L17.5272,2.68 C17.7416,2.3316 17.6076,1.876 17.2592,1.6884 C16.9108,1.474 16.4552,1.608 16.2676,1.9564 L15.5976,3.1356 C15.3832,3.4572 15.4904,3.9128 15.8388,4.1272 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/Lightbulb.bc60880d.svg";
export { ForwardRef as ReactComponent };